import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Aircraft } from '@shared/models/activity-summary/aircraft';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-reg-details-dialog',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './reg-details-dialog.component.html',
  styleUrl: './reg-details-dialog.component.scss'
})
export class RegDetailsDialogComponent {

  aircraft?: Aircraft;

  constructor(
      private config: DynamicDialogConfig
    ) { }

  ngOnInit() {
    this.aircraft = this.config.data;
    
  }

  aircraftMfr(aircraft: Aircraft): string {
    return aircraft.type?.short?.startsWith('B') ? 'Boeing' : 'Airbus';
  }

  stripNchar(aircraft: Aircraft): string {
    return aircraft.id.replace('N', '');
  }
}
